<mat-toolbar>
  <span translate>UPLOADER</span>
</mat-toolbar>
<div class="container-fluid">
  <div class="row mt-3">
    @if (!interfaces.length) {
      <p class="text-center p-3 w-100">Nincs elérhető interface eszköz.</p>
    }

    @if (interfaces.length) {
      <mat-form-field class="w-100">
        <mat-label>Interface</mat-label>
        <mat-select [(ngModel)]="item.id">
          @for (i of interfaces; track i) {
            <mat-option [value]="i.id" (click)="onInterfaceSelect(i)">
              {{i.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  @if (item && item.id) {
    <div class="row mt-1">
      @if (item.uploadedFiles && item.uploadedFiles.length) {
        <table class="w-100 table uploaded-files-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Upload date</th>
              <th>Size</th>
            </tr>
          </thead>
          <tbody>
            @for (file of item.uploadedFiles; track file) {
              <tr>
                <td><mat-icon class="align-text-bottom">note</mat-icon> {{file.id}}</td>
                <td>{{file.uploaded ? file.uploaded : ''}}</td>
                <td>{{file.size}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (isUploading) {
        <mat-progress-bar class="my-2" mode="indeterminate"></mat-progress-bar>
      }
      <div class="dnd-container rounded" appDnd (fileDropped)="onFileDropped($event)">
        <input type="file" #fileDropRef id="fileDropRef" [accept]="config.type" (change)="fileBrowseHandler($event.target.files)" />
        <mat-icon>cloud_upload</mat-icon>
        <h3>Drag and drop file here or click to browse for file</h3>
        <small>Allowed file types: {{config.type}}. Maximum upload size limiz: {{config.size_limit}} MB. Allowed upload count: {{config.count}}</small>
      </div>
    </div>
  }
</div>
